import { extractHitLocationData, hit_set, invalid_set } from "./PersonalDataProcess"
import { getDecimalData, getPercentageData } from "./utilFuncs"

const labelAreaIndex = (distance, angle) => {
  let idx = -1
  // assign index by the location
  if (angle > 135 || angle < 45) return idx
  if (distance > 180) {
    idx = Math.min(Math.floor((135-angle)/15), 5)
  } else {
    idx = Math.min(Math.floor((135-angle)/18) + 6, 10)
  }
  return idx
}
export const calculateLocationPortions = (data) => {
  // calculate distribution in each area
  let original = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let count = 0
  for (const i of data) {
    let index = labelAreaIndex(parseFloat(i.ExitDistance), parseFloat(i.Theta))
    if (index) {
      original[index]++
      count++
    }
  }
  return original.map((e) => (Math.round(e*100/count)))
}
export const calculateHitTypePortion = (data) => {
  // calculate percentage by hit type
  let cumulated = { GROUND: 0, LINE: 0, FLYB: 0 }
  let namemap = { GROUND: '滾地球', LINE: '平飛球', FLYB: '高飛球' }
  let count = 0
  for (const i of data) {
    if (cumulated[i.HitType] === undefined) {
      if (i.HitType === 'POPB') {
        cumulated.FLYB++
        count++
      }
    } else {
      cumulated[i.HitType]++
      count++
    }
  }
  let output = []
  for (const key in cumulated) {
    output.push({tag: namemap[key], usage:Math.round(cumulated[key]*100/count)})
  }
  return output
}

const resolveZoneData = (data) => {
  // console.log(data)
  let groupByLabel = {}, count = 0
  // console.log(data)
  // resolve zone chart data
  for (const p of data) {
    if (!(invalid_set.includes(p.APP_KZoneY) && invalid_set.includes(p.APP_KZoneZ))) {
      let label = p.TaggedPitchType
      if (groupByLabel[label] === undefined) groupByLabel[label] = []
      groupByLabel[label].push({label, g: p.GameNo, inn: p.Inning, p: p.Pitcher, b: p.Batter, pr: p.PA_Result, x: parseFloat(p.APP_KZoneY), y: parseFloat(p.APP_KZoneZ), plateid: p.plate_id})
      count++
    }
  }
  let usage = []
  for (const t in groupByLabel) {
    usage.push({tag: t, usage: getDecimalData(groupByLabel[t].length*100, count, 1, 0)})
  }

  return { data: groupByLabel, usage }
}

const calculateLocationPortionByType = (data) => {
  // calculate location portion by hit type
  let output = {
    GROUND: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    LINE: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    FLYB: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    H: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  }
  let count = { GROUND: 0, LINE: 0, FLYB: 0, H: 0 }
  let hit = { GROUND: 0, LINE: 0, FLYB: 0 }

  for (const i of data) {
    let index = labelAreaIndex(parseFloat(i.ExitDistance), parseFloat(i.Theta))
    let type_label = i.HitType==='POPB'? 'FLYB':i.HitType
    if (index && output[type_label]) {
      output[type_label][index]++
      count[type_label]++
      if (hit_set.includes(i.PA_Result)) {
        output.H[index]++
        count.H++
        hit[i.HitType]++
      }
    }
  }
  let total = 0
  // calculate percentage in each area of each hit type
  for (const i in output) {
    output[i] = output[i].map((e) => (Math.round(e*100/count[i])))
  }
  let avg = {}, conq = {}
  // calculate batting avergae in each area
  for (const i in hit) {
    avg[i] = getDecimalData(hit[i], count[i], 3, 0)
    total += count[i]
  }
  // calculate hit distribution in each area
  for (const i in hit) {
    conq[i] = getPercentageData(count[i], total, 1)
  }

  return { portion: output, avg, hit, count, conq, total }
}



export const processLocationData = (data) => {
  let hitLocationData = extractHitLocationData(data)
  let hitTypePortion = calculateHitTypePortion(data)
  let LocationPortion = calculateLocationPortions(data)
  let zoneData = resolveZoneData(data)
  let overview = calculateLocationPortionByType(data)

  return { hit: hitLocationData, type: hitTypePortion, portion: LocationPortion, zone: zoneData, overview  }
}